import { useMediaQuery, useTheme } from "@mui/material";

/**
 * Global hook for mobile landscape detection
 * Returns true when device is mobile AND in landscape orientation
 * 
 * Usage:
 * const isLandscape = useLandscape();
 */
export default function useLandscape() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md")); // < 900px
  const isLandscape = useMediaQuery("(orientation: landscape)");
  const isShortHeight = useMediaQuery("(max-height: 600px)"); // Typical landscape constraint
  
  // Mobile landscape = mobile device + landscape orientation + short height
  return isMobile && isLandscape && isShortHeight;
}



